export const TOASTR_ACTION_TRIGGERED = 'app/components/Toastr/TOASTR_ACTION_TRIGGERED';
export const TOASTR_HIDE_ACTIVE = 'TOASTR_HIDE_ACTIVE';
